import {createRoot, hydrateRoot} from 'react-dom/client';
import CoachingSessions from '../pages/CoachingSessions/CoachingSessions'
import "../index.css";
import "../pages/CoachingSessions/CoachingSessions.module.css"

type AnyProps = Record<string, any>;

let root:
   | ReturnType<typeof createRoot>
    | ReturnType<typeof hydrateRoot>
        | null = null;

function mount(el: HTMLElement, props: AnyProps = {}) {
console.log("Rendering......")
root = createRoot(el);
root.render(<CoachingSessions {...(props as any)}/>);
}

function hydrate(el: HTMLElement, props: AnyProps = {}) {
console.log("Hydrating......")
root = hydrateRoot(el, <CoachingSessions {...(props as any)}/>);
}

function unmount() {
root?.unmount?.();
root = null;
}

if (typeof window !== 'undefined') (window as any).CoachingSessionsVC = {mount, hydrate, unmount}